<template>
  <div class="popup-response error-popup popup-all" style="display: block">
    <div class="popup-container">
      <div class="popup-vue has-header">
        <div class="popup-content-on-mob" style="max-width: 100%;">

          <div class="popup-img">
            <img src="/img/credit-landing-vue/response-error.svg" alt="error">
          </div>

          <div class="popup-title" style="max-width: 100%;">
            {{__t('За даним номером телефону вже існує заявка, очікуйте на дзвінок від фахівця')}}
          </div>

          <div class="button-wrapper page-bottom ">
            <a id="closePopupFocusId" tabindex="0" class="single-button btn violet-btn" @click="popupClose()" @keydown.enter.prevent="popupClose()">{{__t('Закрити')}}</a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'popup-error',
        props: [],
        data() {
            return {}
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            popupClose: function () {
                this.$emit('popupErrorHide')
            }
        }
    }

</script>
